import React from 'react';

// Custom Year Widget that restricts input to 4 digits max with customizable range
const YearWidget = props => {
  // eslint-disable-next-line react/prop-types
  const { value, onChange, placeholder, disabled, readonly, options = {} } = props;
  const { minYear = 1600, maxYear = new Date().getFullYear() } = options;

  const handleChange = event => {
    let inputValue = event.target.value;
    inputValue = inputValue.replace(/\D/g, '');
    if (inputValue.length > 4) {
      inputValue = inputValue.slice(0, 4);
    }

    onChange(inputValue);
  };

  return (
    <input
      type="text"
      className="form-control"
      value={value || ''}
      placeholder={placeholder}
      onChange={handleChange}
      disabled={disabled}
      readOnly={readonly}
      maxLength={4}
      pattern="[0-9]*"
      inputMode="numeric"
      title={`Enter a year between ${minYear} and ${maxYear}`}
    />
  );
};

export default YearWidget;
